module.exports = __webpack_public_path__ + "img/396.b792aa94.jpg";